export default __webpack_public_path__ + "static/Perfect6-4d545ec91c3dcad3556d53f5fc136674.jpg";